import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Calendar } from "src/app/class/calendar";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class CalendarService {
  constructor(private httpClient: HttpClient) { }

  public getMsCalendarAll() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsCalendar/getMsCalendarAll`
    );
  }


  public checkIsVactionOrNot(date: any, listDateOffset: any = []) {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    
   
    if (newDate.getDay() == 0 || newDate.getDay() == 6) {
      return true;
    }

    const dateTimestamp = newDate.getTime();
    if (listDateOffset.includes(dateTimestamp)) {
      return true;
    }
    
    return false;
}
  public checkDuplicateLeave(date: any, dayLeaves: any = []) {
    const newDate = new Date(date);
    if (dayLeaves.includes(newDate.getDate())) {
      return true;
    }
    return false
  }

  // public checkIsThisMouth(monthSt: any, monthN: any) {
  //   console.log("check is this month", monthSt, this.month(monthN));
  //   if (monthSt.toLowerCase() == this.month(monthN).toLowerCase()) {
  //     return true;
  //   }
  //   return false;
  // }

  public checkIsThisMonth(monthSt: any, monthN: number, date: number): boolean {
    console.log(date);

    console.log("Checking month:", monthSt, this.month(monthN));
    if (monthN == 13) {
      monthN -= 1;
      if (monthSt.toLowerCase() == this.month(monthN).toLowerCase() && date >= 26 && date <= 31) {
        return true;
      }
    }
    // DELETE WHEN ALL EMPLOYEE SEND TIMESHEET 01/2568
    // else if (monthN == 1) {
    //   if (monthSt.toLowerCase() == this.month(monthN).toLowerCase() && date >= 1 && date <= 31) {
    //     return true;
    //   }
    // } else {
      let lastMonth = this.month(monthN - 1);
      if (monthN == 1) {
        lastMonth = this.month(12);
      }
      console.log(lastMonth);

      let lastDaylastMonth = new Date(new Date().getFullYear(), monthN - 1, 0).getDate();
      console.log(lastDaylastMonth);

      if (monthSt.toLowerCase() == this.month(monthN).toLowerCase() && date >= 1 && date <= 25) {
        return true;
      } else if (monthSt.toLowerCase() == lastMonth.toLowerCase() && date >= 26 && date <= lastDaylastMonth) {
        return true;
      }
    // }
   return false;
  }

  private month(value: any): any {
    let month: any;
    if (value === 1) {
      month = "January";
    } else if (value === 2) {
      month = "February";
    } else if (value === 3) {
      month = "March";
    } else if (value === 4) {
      month = "April";
    } else if (value === 5) {
      month = "May";
    } else if (value === 6) {
      month = "June";
    } else if (value === 7) {
      month = "July";
    } else if (value === 8) {
      month = "August";
    } else if (value === 9) {
      month = "September";
    } else if (value === 10) {
      month = "October";
    } else if (value === 11) {
      month = "November";
    } else if (value === 12) {
      month = "December";
    }

    return month;
  }

  public addMsCalendar(calendar: Calendar): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.url}/apiMsCalendar/addMsCalendar`,
      calendar
    );
  }

  public getMsCalendarByYearAndMonth(
    offset: number,
    pageSize: number,
    field: string,
    year: number,
    month: number,
    isAscending: boolean,
    searchText: string
  ) {
    let params = new HttpParams();
    params = params.append("year", year);
    params = params.append("month", month);
    params = params.append("isAscending", isAscending);
    params = params.append("searchText", searchText);
    return this.httpClient.get<any>(
      `${environment.url}/apiMsCalendar/getMsCalendarByYearAndMonth/${offset}/${pageSize}/${field}`,
      { params: params }
    );
  }

  public deleteMsCalendar(id: number) {
    return this.httpClient.delete<any>(
      `${environment.url}/apiMsCalendar/deleteMsCalendar/${id}`
    );
  }

  public addListMsCalendar(body: any) {
    return this.httpClient.post<any>(
      `${environment.url}/apiMsCalendar/addListMsCalendar`,
      body
    );
  }

  public updateMsCalendar(id: number, dayOff: string, dayDesc: string): Observable<any> {
    const body = {
      id,
      dayOff,
      dayDesc
    };

    return this.httpClient.put(
      `${environment.url}/apiMsCalendar/updateMsCalendar`,
      body,
      { responseType: 'text' }
    );
  }

exportMsCalendar(year: number): Observable<Blob> {
  return this.httpClient.get(`${environment.url}/apiMsCalendar/export-calendar-by-year?year=${year}`, {
    responseType: 'blob'
  });
}



public importCalendar(formData: FormData): Observable<any> {
  return this.httpClient.post(
    `${environment.url}/apiMsCalendar/import-calendar`,
    formData
  );
}
}

